export enum BillingColumns {
  'date' = 'date',
  'description' = 'description',
  'quantity' = 'quantity',
  'unitHT' = 'unitHT',
  'totalHT' = 'totalHT',
  'vatRate' = 'vatRate',
  'vat' = 'vat',
  'unitTTC' = 'unitTTC',
  'totalTTC' = 'totalTTC',
  'ownerFeesRate' = 'ownerFeesRate',
  'unit' = 'unit',

  //for pdf synthesis
  'deposit' = 'deposit',
  'balance' = 'balance',
}
